<div class="flex gap-2">
  <app-pan-button
    color="danger"
    icon="delete"
    [swal]="removeLocation"
    matTooltip="Remove Location"
    data-testid="bl-location-group-remove-location-button"
  ></app-pan-button>
</div>

<swal
  #removeLocation
  title="Remove Location?"
  text="Are you sure you want to remove {{ params.data.name }} from the location group?"
  icon="warning"
  confirmButtonText="Yes, Remove"
  [showCancelButton]="true"
  [focusCancel]="true"
  (confirm)="params.removeCallback(params.data)"
>
</swal>
